import gql from 'graphql-tag';

export default gql`
    query GetAllMessages($input: AllMessageInput, $offset: Int) {
        getAllMessages(input: $input, offset: $offset) {
            messageId
            conversationId
            creationDate
            conversationName
            isFromDriver
            loadId
            lastMessageRead
            bodyMessage
            messageType
            driverName
            deadLineDateTime
            wasDelivered
            isDeleted
            isGrupal
            driver {
                id
                name
                driverCompanyName
                isDeleted
                isAssigned
                isManual
                isAvailable
                isPreferred
                isShiftStarted
                driverCellNumber
            }
            message {
                id
                creationDate
                bodyMessage
                messageType
            }
            totalCount
        }
    }
`;
